<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="integialTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
      </wt-form-table-list>
    </wt-form-table>

  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_SITEINTEGRAL',
        formComponent: {
          view: { type: 'component', componentName: 'siteIntegral-view', value: 'querySiteIntegralDetailsDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/integralRules/pointsRecordList' }
        },
        formInputsData: [
          // { name: '手机号', key: 'keyWord', value: '', type: 'text' },
          { name: '时间', key: 'dataTimeRange', value: [], type: 'datetime' },
          { name: '站点',
            key: 'siteId',
            value: '',
            type: 'cascader',
            filterable: true,
            options: [],
            props: {
              children: 'childList', label: 'name', value: 'id', expandTrigger: 'hover', emitPath: false }}
          // { name: '站点', key: 'communityId', value: '', type: 'select', data: [], filterable: true }
        ],
        formButtonsData: [
          // { name: '导出Excel',
          //   key: 'EXPORT',
          //   action: 'EXCEL',
          //   hidden: false,
          //   url: window.wtConst.BASE_API + '/modules/userIntegralDetails/userIntegralListImport',
          //   fileName: '站点积分',
          //   permission: 'EXPORT' }
        ],
        formTableData: [
          { name: '站点', key: 'siteName', type: 'text' },
          { name: '积分总数', key: 'totalPoints', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true }
      },
      options: []
    }
  },
  mounted() {
    // this.requestcommunityList()
    this.orgTreeList()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log('data', data)
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setSiteIntegralDetailsDetailData', data.row)
        }
      }
    },
    // 站点
    orgTreeList() {
      this.$api.siteManage.org.orgTreeList().then(res => {
        // this.$wtUtil.setSiteLevelKey(res.data)
        this.form.formInputsData[1].options = res.data
      })
    },

    /*  ------------------------- 接口请求  -------------------------  */
    requestcommunityList() {
      request({
        url: '/modules/community/communityNoPageList',
        method: 'post'
      }).then(res => {
        if (res.code === '0') {
          for (const item of res.data) {
            item.label = item.name
            item.value = item.id
          }
          this.form.formInputsData[1].data = res.data
        }
      })
    }
  }
}
</script>
